export default __webpack_public_path__ + "static/media/keto_giving_up@2x.800976fe.jpg";